import Popup from './layout.vue'

export default Popup
